import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border-top: 0.8px solid #e2e2e2;
  box-shadow: 0px 4px 4px 0px #00000040;
`

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.4rem !important;
  font-weight: 600;
  color: #2c2c2c;
  margin-bottom: 12px;

  > svg {
    font-size: 1.8rem;
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`

export const IconCircle = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 11px;
    height: 11px;
    color: #2c2c2c;
  }
`

export const CardValue = styled.div`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
`

export const ConsultationsCount = styled.div`
  font-size: 3.6rem;
  font-weight: 700;
  color: #2c2c2c;
  text-align: center;
`

export const ProductionCard = styled(Card)`
  background: linear-gradient(162.08deg, #fef8e9 23.74%, #ffffff 62%);
  border: 0.8px solid #ff5100;
  box-shadow: 0px 4px 4px 0px #00000040;

  ${CardTitle} {
    font-size: 1.4rem !important;
    font-weight: 600;
    color: #ff5100;

    svg {
      color: #ff5100;
    }
  }

  ${CardValue} {
    font-size: 2.6rem;
    font-weight: 700;
    color: #2c2c2c;
  }
`

export const ConsultationsList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.4rem !important;
    font-weight: 500;
    color: #2c2c2c;
  }
`

export const Dot = styled.span<{ color: string; size?: number }>`
  width: ${({ size = 8 }) => size}px;
  height: ${({ size = 8 }) => size}px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const PaymentStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .status-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.4rem !important;
    font-weight: 600;
  }

  .status-detail {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .label {
    font-size: 1.2rem !important;
    font-weight: 500;
    color: #2c2c2c;
  }

  .value {
    font-size: 1.4rem !important;
    font-weight: 500;
    color: #2c2c2c;
    text-transform: capitalize;
  }
`

export const ProductionSection = styled(Card)`
  margin-top: 16px;

  h2 {
    font-size: 1.6rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black};
    margin: 0;
  }

  .section-subtitle {
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.gray80};
    margin-top: 4px;
  }
`

export const Timeline = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding-bottom: 8px;
  overflow-x: auto;
`

export const MonthButton = styled.button<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-shrink: 0;
  width: 115px;
  /* height: 150px; reativar junto com SHOW_PAYMENT_FORECAST */
  padding: 12px;
  border-radius: 10px;
  background: ${({ isSelected }) => (isSelected ? '#fff1e0' : 'transparent')};
  border: 1px solid
    ${({ isSelected }) => (isSelected ? '#ff5100' : 'transparent')};

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  .month-label {
    font-size: 1.4rem !important;
    font-weight: 500;
    color: #2c2c2c;
    text-transform: capitalize;
  }

  .month-value {
    font-size: 1.2rem !important;
    font-weight: 600;
    color: #2c2c2c;
  }

  .month-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 103px;
    height: 55px;
    padding: 8px 16px;
    gap: 8px;
    border-radius: 16px;
    text-align: center;
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0px 1px 2px 0px #0c111d1a' : 'none'};
  }
`

export const ProductionFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;

  .closing-status {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .status-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.2rem !important;
    font-weight: 600;
  }

  .dates {
    display: flex;
    gap: 24px;
  }

  .label {
    font-size: 1.2rem !important;
    color: ${({ theme }) => theme.colors.gray60};
  }

  .value {
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.black};
    text-transform: capitalize;
  }

  .accumulated {
    text-align: right;
  }

  .accumulated .value {
    font-size: 1.8rem !important;
    font-weight: 700;
  }
`
